import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AdvData } from './adv-data';
import { AdvService } from './adv.service';

export const advGenerateResolver: ResolveFn<AdvData> = () =>
	inject(AdvService).getAdvData();
